<template>
  <div
    v-show="isShow"
    class="tw:z-[100] tw:fixed tw:inset-0 tw:bg-white"
    tabindex="-1"
    data-slot="quick-conversation-modal"
  >
    <Button
      type="button"
      class="tw:z-[101] tw:absolute tw:top-3 tw:right-4"
      size="icon-sm"
      variant="ghost"
      @click="hide"
    >
      <i class="tw:i-fal-xmark" />
    </Button>

    <QuickConversation v-bind="$attrs" />
  </div>
</template>

<script setup>
import { useScrollLock, useToggle } from '@vueuse/core'
import { watch } from 'vue'
import { Button } from '@/shadcn/components/ui/button/index.js'
import QuickConversation from './quick-conversation.vue'

defineOptions({
  inheritAttrs: false,
})

const [isShow, toggleIsShow] = useToggle(false)
const isLocked = useScrollLock(document.body)

function show() {
  toggleIsShow(true)
}

function hide() {
  toggleIsShow(false)
}

watch(isShow, (isShowNew) => {
  isLocked.value = isShowNew
})

defineExpose({
  show,
})
</script>
